import React, { Component } from "react";
import "./SectionTitle.css";
export default class SectionTitle extends Component {
  render() {
    const color = { color: `${this.props.color}` };
    return (
      <>
        <div className="section-title">
          <span className="befor-section-title" />
          <h2 style={color}>{this.props.children}</h2>
          <span className="after-section-title" />
        </div>
      </>
    );
  }
}
